import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component, Fragment } from "react";
import { bool, array, func, object, string } from "prop-types";
import moment from "moment";
import { Alert, Button, ButtonToolbar, FormGroup, ControlLabel, FormControl, Table } from "@icg360/ui-toolkit";
import { DATE_FORMAT_ISO8601, DATE_FORMAT_UI } from "../../constants";
import { toCurrency } from "../../shared/utils";
import { termPremiumInputs, insuredCancelPreviewFields } from "../../shared/data/previewValues";
import { LABEL as EFFECTIVE_DATE_LABEL } from "../Edit/EffectiveDate";
import { LABEL as COMMENT_LABEL } from "../Edit/Comment";
import RexWrapper from "./RexWrapper";
import RexRenewalPreviewWrapper from "./RexRenewalPreviewWrapper";
import Attachment from "./Attachment";
import Note from "./Note";
import DiscountsAndSurchargesMessage from "./DiscountsAndSurchargesMessage";
import { formFieldPropTypes, pacDataPropTypes } from "../../shared/propTypes";
import styles from "../../shared/styles";
var HIDE_PREMIUM_RULESETS = ["STOP", "PREVENT"];
var BLOCKING_RULESETS = [].concat(HIDE_PREMIUM_RULESETS, ["BLOCK"]);

var Preview = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Preview, _Component);

  function Preview(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.formIsValid = function () {
      var _this$props = _this.props,
          attachment = _this$props.attachment,
          note = _this$props.note;

      if (!attachment.isValid) {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: attachment is invalid.");
        return false;
      }

      if (attachment.isRequired && !attachment.value) {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: attachment is required.");
        return false;
      }

      if (note.isRequired && !note.value) {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: note is required.");
        return false;
      }

      return true;
    };

    _this.handleOnSubmit = function (e) {
      var formSubmitAttempted = _this.state.formSubmitAttempted; // If the form isn't valid, don't bother submitting it

      if (!_this.formIsValid()) {
        e.preventDefault(); // eslint-disable-next-line no-console

        console.warn("NOT SUBMITTING UNTIL VALIDATION");
      } // If a form submit hasn't been marked as attempted yet, mark it as such


      if (!formSubmitAttempted) {
        _this.setState({
          formSubmitAttempted: true
        });
      }
    };

    _this.state = {
      formSubmitAttempted: false
    };
    return _this;
  }
  /**
   * Determine the validity of the form for submitting based on the following:
   * 1. Attachment field is valid
   * 2. Note field is valid
   */


  var _proto = Preview.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        attachment = _this$props2.attachment,
        backToEditFormView = _this$props2.backToEditFormView,
        comment = _this$props2.comment,
        derivedForm = _this$props2.derivedForm,
        effectiveDate = _this$props2.effectiveDate,
        pacData = _this$props2.pacData,
        note = _this$props2.note,
        proposedPolicyData = _this$props2.proposedPolicyData,
        updateFormField = _this$props2.updateFormField,
        rulesetResults = _this$props2.rulesetResults;
    var policyActionId = pacData.policyActionId,
        policyData = pacData.policyData,
        PremiumBearingChange = pacData.rexFormMetadata.PremiumBearingChange;
    var formSubmitAttempted = this.state.formSubmitAttempted;
    var blockingRulesets = rulesetResults.filter(function (ruleset) {
      return ruleset.result === "YES" && BLOCKING_RULESETS.includes(ruleset.trueResult);
    });
    var hidePremium = blockingRulesets.some(function (ruleset) {
      return HIDE_PREMIUM_RULESETS.includes(ruleset.trueResult);
    });
    var formCanSubmit = formSubmitAttempted ? this.formIsValid() : true;
    return /*#__PURE__*/React.createElement("div", null, policyActionId === "discountsandsurcharges" && /*#__PURE__*/React.createElement(DiscountsAndSurchargesMessage, null), policyActionId !== "changeeffectivedate" && policyActionId !== "renewalpreview" && /*#__PURE__*/React.createElement(StaticFormGroup, {
      label: EFFECTIVE_DATE_LABEL,
      value: moment(effectiveDate.value, DATE_FORMAT_ISO8601).format(DATE_FORMAT_UI)
    }), comment.value && /*#__PURE__*/React.createElement(StaticFormGroup, {
      preserveLineWrapping: true,
      label: COMMENT_LABEL,
      value: comment.value
    }), policyActionId === "insuredcancel" ? /*#__PURE__*/React.createElement(Fragment, null, insuredCancelPreviewFields.map(function (field) {
      return /*#__PURE__*/React.createElement(StaticFormGroup, {
        key: field.name,
        label: field.label,
        value: field.type === "currency" ? toCurrency(proposedPolicyData[field.name], true) : proposedPolicyData[field.name]
      });
    })) : /*#__PURE__*/React.createElement("div", {
      style: {
        borderBottom: "1px solid #ddd",
        marginBottom: "20px"
      }
    }, policyActionId !== "renewalpreview" ? /*#__PURE__*/React.createElement(RexWrapper, {
      derivedForm: derivedForm,
      pacData: pacData
    }) : /*#__PURE__*/React.createElement(RexRenewalPreviewWrapper, {
      derivedForm: derivedForm,
      pacData: pacData
    }), PremiumBearingChange === "true" && !hidePremium && /*#__PURE__*/React.createElement(Table, {
      style: {
        margin: "0"
      }
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      colSpan: "4",
      style: styles.sectionDivider
    }, "Term Premium")), termPremiumInputs.map(function (input) {
      return (input.name === "SurplusContribution" && policyData[input.name] > 0 || input.name !== "SurplusContribution") && /*#__PURE__*/React.createElement("tr", {
        key: input.name
      }, /*#__PURE__*/React.createElement("td", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement("strong", null, policyData[input.labelKey] || input.label)), policyActionId !== "renewalpreview" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
        className: "col-xs-3"
      }, toCurrency(policyData[input.name])), /*#__PURE__*/React.createElement("td", {
        className: "col-xs-3"
      }, toCurrency(proposedPolicyData[input.name])), /*#__PURE__*/React.createElement("td", {
        className: "col-xs-2"
      }, toCurrency(proposedPolicyData[input.change]))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
        className: "col-xs-4"
      }, toCurrency(policyData[input.name])), /*#__PURE__*/React.createElement("td", {
        className: "col-xs-4"
      }, toCurrency(proposedPolicyData[input.name]))));
    })))), policyActionId !== "renewalpreview" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Attachment, {
      attachment: attachment,
      formSubmitAttempted: formSubmitAttempted,
      pacData: pacData,
      updateFormField: updateFormField
    }), /*#__PURE__*/React.createElement(Note, {
      formSubmitAttempted: formSubmitAttempted,
      note: note,
      updateFormField: updateFormField
    })), blockingRulesets.map(function (ruleset) {
      return /*#__PURE__*/React.createElement(Alert, {
        key: ruleset.id,
        bsStyle: "danger"
      }, ruleset.message);
    }), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6"
    }, !formCanSubmit && /*#__PURE__*/React.createElement("p", {
      className: "text-danger"
    }, "Fix any issues before saving changes.")), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/React.createElement(ButtonToolbar, {
      className: "pull-right"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: backToEditFormView
    }, "Go Back"), /*#__PURE__*/React.createElement(Button, {
      bsStyle: "primary",
      type: "submit",
      disabled: !formCanSubmit || !!blockingRulesets.length,
      onClick: this.handleOnSubmit
    }, "Process Changes")))));
  };

  return Preview;
}(Component);

Preview.propTypes = {
  attachment: formFieldPropTypes.isRequired,
  backToEditFormView: func.isRequired,
  derivedForm: array.isRequired,
  comment: formFieldPropTypes.isRequired,
  effectiveDate: formFieldPropTypes.isRequired,
  pacData: pacDataPropTypes.isRequired,
  note: formFieldPropTypes.isRequired,
  proposedPolicyData: object.isRequired,
  updateFormField: func.isRequired,
  rulesetResults: array.isRequired
};
export { Preview as default };

function StaticFormGroup(_ref) {
  var label = _ref.label,
      value = _ref.value,
      preserveLineWrapping = _ref.preserveLineWrapping;
  return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "col-xs-4",
    style: {
      textAlign: "left"
    }
  }, label), /*#__PURE__*/React.createElement(FormControl.Static, {
    className: "col-xs-8",
    style: preserveLineWrapping ? {
      whiteSpace: "pre-line"
    } : {}
  }, value));
}

StaticFormGroup.propTypes = {
  label: string.isRequired,
  value: string.isRequired,
  preserveLineWrapping: bool
};